<div style="overflow-x: hidden;">
  <router-outlet />   
</div>